<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>
              <v-flex lg6 v-if="vendorList != ''">
                <label class="blackLabel">* Vendor:</label>
                <v-select :items="vendorList" label="Vendor" class="dropdown" v-model="objVendorSelectEdit.vendorId" autocomplete :rules="vendorRules" item-text="name" item-value="id" solo single-line></v-select>
              </v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Vendor Reference Acccount Number:</label>
					<v-text-field label="Name" v-model="objVendorSelectEdit.reference" required :rules="referenceRules" single-line solo></v-text-field>
				</v-flex>
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncUpdateSelectVendor()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
        return {
                vendorManufacturer: '',
				isAddValid: false,
                vendorReference: '',
				vendorRules: [
					v => !!v || 'Vendor is required',
				],
				referenceRules: [
					v => !!v || 'Reference is required',
                ]
			};
		},
      methods: {
        fncHideModal() {
          this.$store.commit('hideModal');
        },
        fncUpdateSelectVendor() {

          this.$store.dispatch({
            type: 'fncUpdateSelectVendor'
          })

			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
                'runAdd',
                'vendorList',
                'objVendorSelectEdit'
			])
		},
        watch: {
            runAdd() {
                if( this.runAdd === false ) {
                    this.isAddValid = false;
                    this.roleActive = '';
                    this.roleName = '';
                    this.roleDescription = '';
                    this.roleLevel = '';
                    this.roleUserType = '';
                }
            }
        },
        beforeMount() {
          this.$store.dispatch('fncPopulateVendors');
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
